/* Built In Imports */
import NextLink from 'next/link';
import { useEffect, useState } from 'react';
import React from 'react';

/* External Imports */
import { Box, Typography, Flex, Text, Container, Link, Heading } from '@chakra-ui/react';
import { Link as HashLink } from 'react-scroll';
import { useMediaQuery } from 'react-responsive';

/* Services */
/**
 * Renders the AllTopics component
 * @param {Object} sectionContent
 * @returns {ReactElement} AllTopics component
 */
const OfficialDigitalHandles = (sectionContent) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const ipad = useMediaQuery({ maxWidth: 1299 });
  const [inr, setCount] = useState(0);
  
  let rows = 3;
  if(isMobile){
    rows = 1;
  } else if(ipad){
    rows = 2;
  }
  
  //Section one
  const columns = [[], [], []];
  sectionContent?.sectionContent[1]?.body?.value?.document?.children.map((item, index) => {
    columns[index % rows].push(item);
  });

// Section 2
const columns2 = [[], [], []];
  sectionContent?.sectionContent[2]?.body?.value?.document?.children.map((item, index) => {
    columns2[index % rows].push(item);
  });

// Section 3
const columns3 = [[], [], []];
sectionContent?.sectionContent[3]?.body?.value?.document?.children.map((item, index) => {
  columns3[index % rows].push(item);
});

// Section 4

const columns4 = [[], [], []];
sectionContent?.sectionContent[4]?.body?.value?.document?.children.map((item, index) => {
  columns4[index % rows].push(item);
});

// Section 5

const columns5 = [[], [], []];
sectionContent?.sectionContent[5]?.body?.value?.document?.children.map((item, index) => {
  columns5[index % rows].push(item);
});

// Section 6

const columns6 = [[], [], []];
sectionContent?.sectionContent[6]?.body?.value?.document?.children.map((item, index) => {
  columns6[index % rows].push(item);
});

// console.log("7th content", sectionContent?.sectionContent[7]?.body?.value?.document?.children);
// sectionContent?.sectionContent[7]?.body?.value?.document?.children.map((item, index) => {
  
// });

// Section 7
const columns7 = [
  [
    {
      "type": "paragraph",
      "children": [
          {
              "type": "heading",
              "value": "Sadhguru App"
          },
      ]
  },
      {
          "type": "paragraph",
          "children": [
              {
                  "type": "span",
                  "value": " iOS"
              },
              {
                  "url": "https://apps.apple.com/in/app/sadhguru-yoga-meditation/id537568757",
                  "meta": [
                      {
                          "id": "target",
                          "value": "_blank"
                      }
                  ],
                  "type": "link",
                  "children": [
                      {
                          "type": "span",
                          "value": "apps.apple.com/in/app/sadhguru-yoga-meditation/id537568757"
                      }
                  ]
              },
              {
                  "type": "span",
                  "value": " "
              }
          ]
      },
      {
        "type": "paragraph",
        "children": [
            {
                "type": "span",
                "value": "Android Play Store"
            },
            {
                "url": "https://play.google.com/store/apps/details?id=com.ishafoundation.app",
                "meta": [
                    {
                        "id": "target",
                        "value": "_blank"
                    }
                ],
                "type": "link",
                "children": [
                    {
                        "type": "span",
                        "value": "play.google.com/store/apps/details?id=com.ishafoundation.app"
                    }
                ]
            },
            {
                "type": "span",
                "value": "\n"
            }
        ]
    }
  ],
  [
    {
      "type": "paragraph",
      "children": [
          {
              "type": "heading",
              "value": "Miracle of Mind"
          },
      ]
  },
    {
      "type": "paragraph",
      "children": [
          {
              "type": "span",
              "value": " iOS"
          },
          {
              "url": "https://apps.apple.com/in/app/miracle-of-mind-sadhguru/id6737795677",
              "meta": [
                  {
                      "id": "target",
                      "value": "_blank"
                  }
              ],
              "type": "link",
              "children": [
                  {
                      "type": "span",
                      "value": "apps.apple.com/in/app/miracle-of-mind-sadhguru/id6737795677"
                  }
              ]
          }
      ]
  }
    ,
      {
          "type": "paragraph",
          "children": [
              {
                  "type": "span",
                  "value": "Android Play Store"
              },
              {
                  "url": "https://play.google.com/store/apps/details?id=org.sadhguru.miracleofmind",
                  "meta": [
                      {
                          "id": "target",
                          "value": "_blank"
                      }
                  ],
                  "type": "link",
                  "children": [
                      {
                          "type": "span",
                          "value": "play.google.com/store/apps/details?id=org.sadhguru.miracleofmind"
                      }
                  ]
              }
          ]
      }
  ],
  []
]

// Section 8
const columns8 = [[], [], []];
sectionContent?.sectionContent[8]?.body?.value?.document?.children.map((item, index) => {
  columns8[index % rows].push(item);
});

function renderContent(columns, title) {
  if(isMobile){
  return (
     <Box>
          <Heading as="h2"
          color={"#000"}
          lineHeight={"140%"}
          //fontFamily="Fedra Serif A Pro"
          textAlign={'left' }
          fontWeight={title == "Apps" ||  title == "Websites" ? "1000" : "600"}
          fontSize={{base:"20px",sm:"20px", md:title == "Apps" ||  title == "Websites" ? "28px" : "24px"}}
          padding={"8px"}
         >
        {title}
        </Heading>
      {columns.map((col, i) => (
        <Box key={i}
        mb={"30px"}
        >
          {col.map((obj, j) => (
            <Box
              key={j}
              p={"10px"}
              >
              <Text
              color={"#000"}
              lineHeight={"140%"}
              fontFamily="FedraSansStd-book"
              textAlign={'left' }
              fontWeight="600"
              fontSize={"16px"}
              >
                {obj?.children[0]?.value.replace("-", "")}
              </Text>
              <Link
              color={"#000"}
              lineHeight={"140%"}
              fontFamily="FedraSansStd-book"
              textAlign={'left' }
              fontWeight="350"
              fontSize={"16px"}
              sx={{
                textDecorationThickness: isMobile ? "1%" : "0%",
                textDecorationSkipInk: "true",
                textDecoration: 'underline',
                textDecorationColor:'#E44F4F',
              }}
              cursor={"pointer"}
              href={obj?.children[1]?.url}
              target='_blank'
              >
               {obj?.children[1]?.children[0]?.value}
              </Link>

            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
  }else{
    return (
      <Box>

         <Heading as="h2"
          color={"#000"}
          lineHeight={"140%"}
          //fontFamily="Fedra Serif A Pro"
          textAlign={'left' }
          fontWeight={title == "Apps" ||  title == "Websites" ? "1000" : "600"}
          fontSize={{base:"20px",sm:"20px", md:title == "Apps" ||  title == "Websites" ? "28px" : "24px"}}
          padding={"8px"}
         >
         {title}
         </Heading>         
           <Box
           sx={{
             display: 'flex',
             margin: 'auto'
           }}
           >
       {columns.map((col, i) => (
         <Box key={i} sx={{ width: ipad ? "48%" : '32%', display: 'flex', flexDirection: 'column', gap: 2 }}
         mb={"30px"}
         >
           {col.map((obj, j) => (
             <Box
               key={j}
               p={"8px"}
             >
               <Text
               color={"#000"}
               lineHeight={"140%"}
               fontFamily="FedraSansStd-book"
               textAlign={'left' }
               fontWeight={obj?.children[0]?.value == "Sadhguru App" || obj?.children[0]?.value == "Miracle of Mind"?"1000" : "600"}
               fontSize={obj?.children[0]?.value == "Sadhguru App" || obj?.children[0]?.value == "Miracle of Mind"? "20px" : "16px"}
               >
                 {obj?.children[0]?.value.replace("-", "")}

               </Text>
               {obj?.children[1]?.url && (
               <Link
               color={"#000"}
               lineHeight={"140%"}
               fontFamily="FedraSansStd-book"
               textAlign={'left' }
               fontWeight="350"
               fontSize={"16px"}
               //decoration={"underline #E44F4F solid"}
               sx={{
                textDecorationThickness: isMobile ? "1%" : "0%",
                textDecorationSkipInk: "true",
                textDecoration: 'underline',
                textDecorationColor:'#E44F4F',
              }}
               cursor={"pointer"}
               href={obj?.children[1]?.url}
               target='_blank'
               >
                 {obj?.children[1]?.children[0]?.value}
               </Link>
                )}
             </Box>
           ))}
         </Box>
       ))}
     </Box>
     </Box>
   );
  }
  }
  return (
    <Box
      pos="relative"
      float="left"
      w={"100%"}
      p="12px"
      maxW={"1330px"}
    >
      
    <Heading as="h1"
     color={"#000"}
     lineHeight={"140%"}
     //fontFamily="FedraSansStd-book"
     textAlign={'left' }
     fontWeight="1000"
     fontSize={{base:"24px", sm:"24px", md:"28px"}}
     padding={"10px"}
    >
      {sectionContent?.sectionContent[0].titleText}
    </Heading>
 

      {renderContent(columns, "YouTube")}
      {renderContent(columns2, "Instagram")}
      {renderContent(columns3, "Facebook")}
      {renderContent(columns4, "X")}
      {renderContent(columns5, "Linkedin")}
      {renderContent(columns6, "TikTok")}
      {renderContent(columns7, "Apps")}
      {renderContent(columns8, "Websites")}
    </Box>
  );

};

export default OfficialDigitalHandles;